import styled from "styled-components";

export const Header = styled.div`
    background-color: rgb(255, 255, 255);
    border-bottom: 1px solid rgb(224, 224, 224);
    @media(min-width: 768px) {
        padding: 0px 24px;
    }
    
    > .tmp-branding {
        width: 170px;
    }
    `
export const HeaderContainer = styled.div`
    height: 88px;
    display: flex;
    align-items: center; /* Isso centraliza as divs no contêiner */
    text-align: center;  /* Alinhamento padrão para o texto */
    justify-content: center;
`

export const Brand = styled.div`
    display: inline-flex;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
    svg{
        height: 40px;
        width: 170px;
    }
`

export const Right = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
`

export const Center = styled.div`
    text-align: center;
    width: 100%;
    font-weight: 700;
    font-size: 16px;
    color: #666666;
`